<template>
  <div>
    <px-cotacao-frete-resposta-line-options @change-search-text="onChangeSearchText"
                                            @change-sort="onChangeSort"
                                            @refresh="onRefresh"/>
    <div v-if="loading">
      <px-circular-loading/>
    </div>

    <div class="mb-3 text-right" v-if="cotacao.id">
      <px-cotacao-frete-resposta-recusada
        :cotacao-id="cotacao.id"/>
    </div>

    <div v-if="!respostas.length" align="center" class="headline mt-5">
      Nenhuma resposta encontrada
    </div>

    <div class="mt-3" v-if="!loading && respostas.length">
      <v-card>
        <template v-for="(resposta, index) in respostas">
          <px-cotacao-frete-item-list :resposta="resposta" :key="resposta.id"/>
          <v-divider :key="`div-${resposta.id}`" v-if="index < respostas.length - 1"/>
        </template>
      </v-card>
    </div>
  </div>
</template>

<script>
import CotacaoFreteRespostaLineOptions from './CotacaoFreteRespostaLineOptions.vue';
import CotacaoFreteItemList from './CotacaoFreteItemList.vue';
import CotacaoFreteRespostaRecusada from './recusados/CotacaoFreteRespostaRecusada.vue';
import RespostaFreteService from './resposta-frete-service';

export default {
  props: {
    cotacao: Object,
  },
  data() {
    return {
      respostas: [],
      loading: false,
      searchText: null,
      selectedSort: null,
    };
  },
  methods: {
    onChangeSearchText(text) {
      this.searchText = text;
      this.getRespostas();
    },
    onChangeSort(sort) {
      this.selectedSort = sort;
      this.getRespostas();
    },
    onRefresh() {
      this.getRespostas();
    },
    buildQuery() {
      return `${this.buildFilter()} ${this.buildSort()}`.trim();
    },
    buildFilter() {
      if (!this.searchText) {
        return '';
      }
      return `transportadora like "%${this.searchText.toLowerCase()}%"`;
    },
    buildSort() {
      if (!this.selectedSort) {
        return '';
      }
      return `order by ${this.selectedSort.value}`;
    },
    getRespostas() {
      this.loading = true;
      RespostaFreteService.getRespostas(this.cotacao.id, {
        query: this.buildQuery(),
      })
        .then(({ data }) => {
          this.respostas = data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  components: {
    pxCotacaoFreteRespostaLineOptions: CotacaoFreteRespostaLineOptions,
    pxCotacaoFreteItemList: CotacaoFreteItemList,
    pxCotacaoFreteRespostaRecusada: CotacaoFreteRespostaRecusada,
  },
};
</script>
